var lists_default = {
  "fontElementMap": "T7t-V",
  "orderedlist": "aVx5f",
  "bulletedlist": "NA2Lt",
  "listItem": "FsODY"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
